import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Helmet from 'react-helmet'
import RouteDataProvider from '../components/RouteDataProvider';
import ErrorHandler from '../components/ErrorHandler';
import { preloadDMAInfo, updateZipCodeAction } from '../redux/actions/zipCode';
import { initAction } from '../redux/actions/views';
import { getHeliosZip } from '../redux/selectors/helios';

/**
 * App is loaded and sets the different Meta-data values with Helmet it then
 * determines which page view we're on, sets the routes for react-router and
 * checks for errors that need to be handeled at this level.
 */
class App extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    loadDMA: PropTypes.func.isRequired,
    initApp: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
    heliosZip: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    updateZip: PropTypes.func.isRequired
  };
  constructor() {
    super();
    this.state = { hasFired: false };
  }
  componentDidMount() {
    const { loadDMA, initApp, heliosZip, updateZip } = this.props;
    const { hasFired } = this.state;
    if (!hasFired) {
      initApp();
      const newState = this.state;
      newState.hasFired = true;
      this.setState(newState); //eslint-disable-line
    }
    loadDMA();
    if (process.env.VENDOR === 'helios' && heliosZip) {
      // If the vendor is Helios then we determine the zipCode based on the url Param first.
      updateZip(heliosZip);
    }
  }
  render() {
    const { children, title } = this.props;
    // Need to set the SVG color to black for Infiniti or white for Nissan
    const errorColor = process.env.BRAND_NAME === 'nissan' ? '#fff' : '#000';
    return (
      <div>
        <Helmet title={title} />
        <ErrorHandler errorColor={errorColor}>
          <RouteDataProvider params={this.props.params}>
            {children}
          </RouteDataProvider>
        </ErrorHandler>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  title: state.i18n.pageTitle,
  heliosZip: getHeliosZip(state)
});

const mapDispatchToProps = dispatch => ({
  loadDMA: bindActionCreators(preloadDMAInfo, dispatch),
  initApp: bindActionCreators(initAction, dispatch),
  updateZip: bindActionCreators(updateZipCodeAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/pages/App.js
 **/